import { useEffect, useState } from 'react';
import { Modal, message, Form, Button, Checkbox, Radio, InputNumber } from 'antd';
import API from '../../../../services/API';
import LoaderComponent from '../../../Loader';

export default function SubscriptionResumeModal({
  userId,
  subscriptionId,
  refreshList
}) {

  const [modalVisible, setModalVisible] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [isFormDisabled, setIsFormDisabled] = useState(false);

  useEffect(() => {
    setIsFormDisabled(!subscriptionId);
  }, [subscriptionId]);

  const showModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
  }

  const onFinishFailed = (error) => {
    console.log('new error', { ... error});
  };

  const resumeSubscription = async (data) => {
    console.log('resumeSubscription', data);
    
    showModalLoading(true);
    const request = API.resumeSubscription(userId, subscriptionId);

    request.then((resp) => {
      showModalLoading(false);
      setModalVisible(false);
      alert(resp?.message || 'Subscription resumed!')
      if (refreshList) refreshList();
    }).catch((error) => {
      alert(error?.message || 'Something went wrong')
      showModalLoading(false);
    });
  }

  return (
    <>
      <Button type="danger" onClick={showModal} className="mr-5">
        Resume Subscription
      </Button>
      <Modal
        title={'Resume Subscription'}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        open={modalVisible}
        footer={null}
        className="confirm-modal"
      >
        <>
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            onFinish={resumeSubscription}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div>
                <p>This action will resume this subscription. The status will change to ACTIVE state in a few minutes.</p>
            </div>
            <div>
                <Form.Item >
                <Button type="primary" htmlType="submit" disabled={modalLoading || isFormDisabled}>
                  Resume Subscription
                </Button>
                &nbsp;
                <Button htmlType="button" onClick={closeModal} disabled={modalLoading}>
                  Close
                </Button>
                </Form.Item>
            </div>
          </Form>
          {modalLoading && <LoaderComponent />}
        </>
      </Modal>
    </>);

}